import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Container component for vertical lists of {@link ListItemComponent} rows.
 *
 * Wraps its projected children in a block element that can render dividers between
 * rows and/or add vertical spacing. Pair with `<app-list-item>` (or any custom
 * row component) as content.
 *
 * @example
 * <app-list [divide]="true">
 *   <app-list-item title="Goals" />
 *   <app-list-item title="Students" />
 * </app-list>
 *
 * @example Without dividers, with spacing
 * <app-list [divide]="false" [spaceY]="true">
 *   <app-list-item title="Item one" />
 *   <app-list-item title="Item two" />
 * </app-list>
 *
 * @feature shared
 */
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  host: {
    class: 'block',
  },
})
export class ListComponent {
  /**
   * Whether to render 1px dividers between projected list items.
   * @default false
   */
  readonly divide = input<boolean>(false);

  /**
   * Whether to add vertical spacing between projected list items.
   * @default false
   */
  readonly spaceY = input<boolean>(false);
}
